import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { BLUE_BG, LIGHT_BLUE_BG, theme } from "@/theme";
import styled from "@emotion/styled";
import { SizedImage } from "./SizedImage";

type ProductInfo = {
  image: string;
  pageLink?: string;
  title: string;
};

type ImageListProps = {
  products: ProductInfo[];
  numSpaces: number;
  emptyStateLink?: { href: string; ariaLabel: string };
};

export const ImageList = ({
  products,
  emptyStateLink,
  numSpaces,
}: ImageListProps) => {
  const isMobile: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  const size = isMobile ? 40 : 50;
  const numConcat = Math.max(0, numSpaces - products.length);
  const result = products
    .concat(Array(numConcat).fill(undefined))
    .map((p, index) => {
      const SizedBox = styled(Box)({
        height: size,
        width: size,
        ...(index > 0 && { marginLeft: isMobile ? "8px" : "16px" }),
        borderStyle: "solid",
        borderWidth: "1px",
        boxSizing: "content-box",
      });
      if (p === undefined) {
        const emptyBox = (
          <SizedBox
            display="flex"
            key={index}
            bgcolor={LIGHT_BLUE_BG}
            borderColor={BLUE_BG}
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant={"body2"} color={"textPrimary"}>
              #{index + 1}
            </Typography>
          </SizedBox>
        );
        return emptyStateLink ? (
          <a href={emptyStateLink.href} aria-label={emptyStateLink.ariaLabel}>
            {emptyBox}
          </a>
        ) : (
          emptyBox
        );
      }
      return (
        <SizedBox key={p.title} borderColor={theme.palette.secondary.main}>
          <a href={p.pageLink}>
            <SizedImage
              src={p.image}
              alt={p.title}
              width={size}
              height={size}
            />
          </a>
        </SizedBox>
      );
    });
  return <>{result}</>;
};
